import { ReactNode } from 'react';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import { Tabs } from 'features/public/atoms/Tabs/Tabs';

interface Props {
  className?: string;
  title?: ReactNode;
  hasTabs?: boolean;
  children?: ReactNode;
}

export const Layout = ({ className = '', hasTabs = true, title, children }: Props) => (
  <div className={`policy-layout-block ${className}`}>
    {title && (
      <div className="policy-layout__title">
        <TitleBlock size="page" title={title} />
      </div>
    )}

    {hasTabs && <Tabs />}

    {children}
  </div>
);
